<div class="configured-applications-details">
  <h4 class="details-title">Estado de las aplicaciones del producto</h4>

  <p class="requirements-hint">
    Para considerar una aplicación configurada hace falta: (1) Bisual GitHub App instalada con los permisos requeridos, y (2) al menos un
    environment (p. ej. production con git_ref).
  </p>

  @if (totalApplications() === 0) {
    <p class="no-data">No hay aplicaciones registradas para este período.</p>
  } @else {
    <div class="applications-summary">
      <mat-icon class="status-icon connected">check_circle</mat-icon>
      <span>{{ configuredCount() }} de {{ totalApplications() }} aplicaciones configuradas</span>
    </div>

    @if (unconfiguredApplications().length > 0) {
      <div class="applications-list">
        @for (application of unconfiguredApplications(); track application.application_id) {
          <div class="application-row">
            <div class="application-main">
              @if (application.git_url) {
                <a class="application-link" [href]="application.git_url" target="_blank" rel="noopener noreferrer">
                  <span class="application-name">{{ application.application_name }}</span>
                  <mat-icon>open_in_new</mat-icon>
                </a>
              } @else {
                <span class="application-name">{{ application.application_name }}</span>
              }
            </div>

            <div class="application-status disconnected">
              <mat-icon>cancel</mat-icon>
              <span>{{ application.reason_label }}</span>
            </div>
          </div>
        }
      </div>
    }
  }
</div>
